import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, withKeys as _withKeys } from "vue";
const _hoisted_1 = { class: "order-invoice" };
const _hoisted_2 = { class: "customer-section" };
const _hoisted_3 = { class: "section-title" };
const _hoisted_4 = {
    key: 0,
    class: "selected-customer-banner"
};
const _hoisted_5 = { class: "banner-content" };
const _hoisted_6 = { class: "banner-text" };
const _hoisted_7 = { class: "banner-title" };
const _hoisted_8 = { class: "banner-subtitle" };
const _hoisted_9 = { class: "banner-actions" };
const _hoisted_10 = { class: "customer-form" };
const _hoisted_11 = { class: "form-group" };
const _hoisted_12 = ["placeholder"];
const _hoisted_13 = {
    key: 0,
    class: "customer-suggestions"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = { class: "suggestion-main" };
const _hoisted_16 = { class: "suggestion-name" };
const _hoisted_17 = { class: "suggestion-phone" };
const _hoisted_18 = { class: "suggestion-address" };
const _hoisted_19 = { class: "form-group" };
const _hoisted_20 = ["placeholder"];
const _hoisted_21 = { class: "form-group" };
const _hoisted_22 = { class: "phone-input-container" };
const _hoisted_23 = ["value"];
const _hoisted_24 = ["placeholder"];
const _hoisted_25 = { class: "form-group" };
const _hoisted_26 = ["placeholder"];
const _hoisted_27 = {
    key: 0,
    class: "email-error"
};
const _hoisted_28 = { class: "form-group" };
const _hoisted_29 = { value: "dine_in" };
const _hoisted_30 = { value: "click_collect" };
const _hoisted_31 = { value: "delivery" };
const _hoisted_32 = { style: { "display": "flex", "flex-direction": "column", "gap": "5px", "margin-bottom": "10px" } };
const _hoisted_33 = { style: { "display": "flex", "align-items": "center", "gap": "5px" } };
const _hoisted_34 = {
    for: "customer",
    style: { "font-size": "14px" }
};
const _hoisted_35 = { style: { "display": "flex", "align-items": "center", "gap": "5px" } };
const _hoisted_36 = {
    for: "organisation",
    style: { "font-size": "14px" }
};
const _hoisted_37 = { key: 0 };
const _hoisted_38 = { class: "form-group" };
const _hoisted_39 = ["placeholder"];
const _hoisted_40 = { class: "form-group" };
const _hoisted_41 = ["placeholder"];
const _hoisted_42 = {
    key: 1,
    class: "delivery-preference-section"
};
const _hoisted_43 = { class: "delivery-options" };
const _hoisted_44 = { class: "delivery-option" };
const _hoisted_45 = ["disabled"];
const _hoisted_46 = {
    for: "immediat",
    class: "delivery-option-label"
};
const _hoisted_47 = { class: "delivery-option-title" };
const _hoisted_48 = {
    key: 0,
    class: "delivery-option-subtitle"
};
const _hoisted_49 = {
    key: 1,
    class: "delivery-option-subtitle"
};
const _hoisted_50 = { class: "delivery-option" };
const _hoisted_51 = {
    for: "ulterieur",
    class: "delivery-option-label"
};
const _hoisted_52 = { class: "delivery-option-title" };
const _hoisted_53 = { class: "delivery-option-subtitle" };
const _hoisted_54 = {
    key: 0,
    class: "scheduled-delivery"
};
const _hoisted_55 = { class: "form-group" };
const _hoisted_56 = { value: "" };
const _hoisted_57 = ["value"];
const _hoisted_58 = {
    key: 0,
    class: "form-group"
};
const _hoisted_59 = { value: "" };
const _hoisted_60 = ["value"];
const _hoisted_61 = {
    key: 0,
    class: "time-info"
};
const _hoisted_62 = { class: "time-info-text" };
const _hoisted_63 = {
    key: 2,
    class: "delivery-address-section"
};
const _hoisted_64 = { class: "delivery-address-title" };
const _hoisted_65 = {
    key: 0,
    class: "form-group"
};
const _hoisted_66 = { value: "" };
const _hoisted_67 = ["value"];
const _hoisted_68 = { class: "form-group" };
const _hoisted_69 = { class: "postal-code-input-container" };
const _hoisted_70 = ["placeholder", "disabled"];
const _hoisted_71 = {
    key: 0,
    class: "postal-code-suggestions"
};
const _hoisted_72 = ["onClick"];
const _hoisted_73 = { class: "postal-code-number" };
const _hoisted_74 = { class: "postal-code-city" };
const _hoisted_75 = { class: "form-group" };
const _hoisted_76 = ["placeholder", "disabled"];
const _hoisted_77 = { class: "form-group" };
const _hoisted_78 = ["placeholder", "disabled"];
const _hoisted_79 = { class: "form-group" };
const _hoisted_80 = ["placeholder", "disabled"];
const _hoisted_81 = { class: "cart-section" };
const _hoisted_82 = { class: "section-header" };
const _hoisted_83 = { class: "section-title" };
const _hoisted_84 = { class: "item-count" };
const _hoisted_85 = { class: "cart-items" };
const _hoisted_86 = { class: "item-image" };
const _hoisted_87 = ["src", "alt"];
const _hoisted_88 = { class: "item-details" };
const _hoisted_89 = { class: "item-name" };
const _hoisted_90 = { class: "item-size" };
const _hoisted_91 = {
    key: 0,
    class: "item-customization"
};
const _hoisted_92 = { class: "customization-label" };
const _hoisted_93 = { class: "ingredients-list" };
const _hoisted_94 = {
    key: 1,
    class: "item-customization"
};
const _hoisted_95 = { class: "customization-label" };
const _hoisted_96 = { class: "ingredients-list" };
const _hoisted_97 = {
    key: 2,
    class: "item-customization"
};
const _hoisted_98 = { class: "customization-label" };
const _hoisted_99 = { class: "ingredients-list" };
const _hoisted_100 = {
    key: 3,
    class: "item-customization"
};
const _hoisted_101 = { class: "customization-label" };
const _hoisted_102 = { class: "ingredients-list" };
const _hoisted_103 = {
    key: 4,
    class: "item-notes"
};
const _hoisted_104 = { class: "item-controls" };
const _hoisted_105 = { class: "quantity-controls" };
const _hoisted_106 = ["onClick"];
const _hoisted_107 = { class: "quantity" };
const _hoisted_108 = ["onClick"];
const _hoisted_109 = { class: "item-price" };
const _hoisted_110 = { class: "price" };
const _hoisted_111 = ["onClick"];
const _hoisted_112 = {
    key: 0,
    class: "empty-cart"
};
const _hoisted_113 = {
    key: 1,
    class: "order-summary"
};
const _hoisted_114 = { class: "section-title" };
const _hoisted_115 = { class: "coupon-section" };
const _hoisted_116 = { class: "coupon-title" };
const _hoisted_117 = {
    key: 0,
    class: "min-order-info"
};
const _hoisted_118 = { class: "min-order-message" };
const _hoisted_119 = { class: "min-order-text" };
const _hoisted_120 = {
    key: 0,
    class: "min-order-warning"
};
const _hoisted_121 = {
    key: 1,
    class: "applied-coupons-list mb-10"
};
const _hoisted_122 = { class: "coupon-info" };
const _hoisted_123 = { class: "coupon-code" };
const _hoisted_124 = { class: "coupon-discount" };
const _hoisted_125 = ["onClick"];
const _hoisted_126 = {
    key: 2,
    class: "coupon-form"
};
const _hoisted_127 = { class: "coupon-input-group" };
const _hoisted_128 = ["placeholder", "disabled"];
const _hoisted_129 = ["disabled"];
const _hoisted_130 = {
    key: 0,
    class: "fas fa-spinner fa-spin"
};
const _hoisted_131 = { key: 1 };
const _hoisted_132 = {
    key: 0,
    class: "min-order-controls d-flex flex-column",
    style: { "gap": "10px" }
};
const _hoisted_133 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_134 = { class: "btn-text" };
const _hoisted_135 = { class: "btn-text" };
const _hoisted_136 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_137 = { class: "discount-section" };
const _hoisted_138 = { class: "form-group" };
const _hoisted_139 = { class: "discount-type-selector" };
const _hoisted_140 = { class: "discount-type-option" };
const _hoisted_141 = { class: "discount-type-option" };
const _hoisted_142 = { class: "form-group" };
const _hoisted_143 = { key: 0 };
const _hoisted_144 = { key: 1 };
const _hoisted_145 = { class: "discount-input-group" };
const _hoisted_146 = { class: "discount-symbol" };
const _hoisted_147 = { class: "divers-section" };
const _hoisted_148 = { class: "form-group" };
const _hoisted_149 = { class: "discount-input-group" };
const _hoisted_150 = { class: "divers-section" };
const _hoisted_151 = { class: "form-group" };
const _hoisted_152 = { class: "discount-input-group" };
const _hoisted_153 = { class: "divers-section" };
const _hoisted_154 = { class: "form-group" };
const _hoisted_155 = { class: "discount-input-group" };
const _hoisted_156 = ["placeholder"];
const _hoisted_157 = { class: "summary-lines" };
const _hoisted_158 = { class: "summary-row" };
const _hoisted_159 = { class: "label" };
const _hoisted_160 = { class: "value" };
const _hoisted_161 = {
    key: 0,
    class: "summary-row"
};
const _hoisted_162 = { class: "label" };
const _hoisted_163 = { key: 0 };
const _hoisted_164 = { key: 1 };
const _hoisted_165 = { class: "value discount-value" };
const _hoisted_166 = {
    key: 1,
    class: "summary-row"
};
const _hoisted_167 = { class: "label" };
const _hoisted_168 = { class: "value discount-value" };
const _hoisted_169 = {
    key: 2,
    class: "summary-row"
};
const _hoisted_170 = { class: "label" };
const _hoisted_171 = { class: "value supplement-value" };
const _hoisted_172 = {
    key: 3,
    class: "summary-row"
};
const _hoisted_173 = { class: "value supplement-value" };
const _hoisted_174 = {
    key: 4,
    class: "summary-row"
};
const _hoisted_175 = { class: "label" };
const _hoisted_176 = { class: "value divers-value" };
const _hoisted_177 = { class: "summary-row" };
const _hoisted_178 = { class: "label" };
const _hoisted_179 = { class: "value" };
const _hoisted_180 = { class: "summary-row total" };
const _hoisted_181 = { class: "label" };
const _hoisted_182 = { class: "value" };
const _hoisted_183 = {
    key: 2,
    class: "payment-section"
};
const _hoisted_184 = { class: "section-title" };
const _hoisted_185 = { class: "payment-methods" };
const _hoisted_186 = ["onClick"];
const _hoisted_187 = { class: "payment-icon" };
const _hoisted_188 = {
    key: 3,
    class: "action-section"
};
const _hoisted_189 = ["disabled"];
const _hoisted_190 = { class: "order-total" };
import { ref, computed, onMounted, watch } from "vue";
import { createPOSOrder, detailRestaurant, getUserAddresses, applyCoupon, getRestaurantDetails, getAllPostalCodes, calculateMinimumAmount, getPosClient, } from "@/service/api";
import { getAllCustomers } from "@/service/api";
import { UserGeneralKey } from "@/models/user.generalkey";
import { useToast } from "vue-toastification";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";
import { calculateItemTotalPrice } from "@/utils/priceCalculations";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderInvoice',
    props: {
        cart: {},
        orderSummary: {},
        categories: {}
    },
    emits: ["update-quantity", "remove-item", "place-order"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const storeCart = computed(() => store.getters["cart/cart"] || []);
        const storeCartTotal = computed(() => store.getters["cart/cartTotal"] || 0);
        const emit = __emit;
        const customerInfo = ref({
            id: "",
            firstName: "",
            lastName: "",
            phone: "",
            email: "",
        });
        const phoneCountryCodes = [
            { code: "+41", flag: "🇨🇭", prefix: "+41" },
            { code: "+33", flag: "🇫🇷", prefix: "+33" },
            { code: "+49", flag: "🇩🇪", prefix: "+49" },
            { code: "+39", flag: "🇮🇹", prefix: "+39" },
            { code: "+44", flag: "🇬🇧", prefix: "+44" },
            { code: "+1", flag: "🇺🇸", prefix: "+1" },
            { code: "+32", flag: "🇧🇪", prefix: "+32" },
            { code: "+43", flag: "🇦🇹", prefix: "+43" },
            { code: "+91", flag: "🇮🇳", prefix: "+91" },
            { code: "+221", flag: "🇸🇳", prefix: "+221" },
            { code: "+212", flag: "🇲🇦", prefix: "+212" },
            { code: "+213", flag: "🇩🇿", prefix: "+213" },
            { code: "+216", flag: "🇹🇳", prefix: "+216" },
            { code: "+234", flag: "🇳🇬", prefix: "+234" },
            { code: "+27", flag: "🇿🇦", prefix: "+27" },
            { code: "+351", flag: "🇵🇹", prefix: "+351" },
            { code: "+34", flag: "🇪🇸", prefix: "+34" },
            { code: "+31", flag: "🇳🇱", prefix: "+31" },
            { code: "+46", flag: "🇸🇪", prefix: "+46" },
            { code: "+47", flag: "🇳🇴", prefix: "+47" },
            { code: "+45", flag: "🇩🇰", prefix: "+45" },
            { code: "+358", flag: "🇫🇮", prefix: "+358" },
            { code: "+7", flag: "🇷🇺", prefix: "+7" },
            { code: "+86", flag: "🇨🇳", prefix: "+86" },
            { code: "+81", flag: "🇯🇵", prefix: "+81" },
            { code: "+82", flag: "🇰🇷", prefix: "+82" },
            { code: "+61", flag: "🇦🇺", prefix: "+61" },
            { code: "+64", flag: "🇳🇿", prefix: "+64" },
            { code: "+55", flag: "🇧🇷", prefix: "+55" },
            { code: "+52", flag: "🇲🇽", prefix: "+52" },
            { code: "+54", flag: "🇦🇷", prefix: "+54" },
        ];
        const selectedCountryCode = ref("+41");
        const customerSuggestions = ref([]);
        const allCustomers = ref([]);
        const searchTimeout = ref(null);
        const selectedCustomer = ref(null);
        const storeOrderType = computed({
            get: () => store.getters["orderType/selectedOrderType"] || "dine_in",
            set: (value) => store.dispatch("orderType/setOrderType", value),
        });
        const selectedOrderType = ref("dine_in");
        onMounted(async () => {
            selectedOrderType.value =
                store.getters["orderType/selectedOrderType"] || "dine_in";
            loadRestaurantInfo();
            loadAllPostalCodes();
            // Detect if an incoming call is triggering this page load
            const hasPhoneParam = !!(route.query.phone || route.query.caller);
            // Always await restaurantDetails so subscription check in initPhoneFromUrl works
            await loadRestaurantDetails();
            // Only load the default POS client if there's no caller phone param
            // (otherwise the default client would override the caller's pre-fill)
            if (!hasPhoneParam) {
                await loadPosClient();
            }
            await initPhoneFromUrl();
            document.addEventListener("click", (event) => {
                const target = event.target;
                if (!target.closest(".customer-form")) {
                    closeSuggestions();
                }
                if (!target.closest(".postal-code-input-container")) {
                    showPostalCodeSuggestions.value = false;
                }
            });
        });
        const selectedPaymentMethod = ref("pay_click_collect_cash");
        const taxRate = ref(2.6);
        const vatAmount = computed(() => (storeCartTotal.value * taxRate.value) / 100);
        const clientType = ref("customer");
        const organisationInfo = ref({
            societe: "",
            departement: "",
        });
        const deliveryPreference = ref("immediat");
        const selectedDate = ref("");
        const selectedTime = ref("");
        const isProcessingOrder = ref(false);
        const restaurantInfo = ref(null);
        const discountType = ref("percentage");
        const discountPercentage = ref(0);
        const discountFixed = ref(0);
        const diversAmount = ref(0);
        const SpecialInstructions = ref("");
        const isTrancher = ref(false);
        const couponCode = ref("");
        const appliedCoupons = ref([]);
        const isApplyingCoupon = ref(false);
        const restaurantDetails = ref(null);
        const restaurantMinOrder = ref(0);
        const restaurantDeliveryFee = ref(0);
        const originalMinOrder = ref(0);
        const originalDeliveryFee = ref(0);
        const allPostalCodes = ref([]);
        const posClient = ref(null);
        const postalCodeSuggestions = ref([]);
        const showPostalCodeSuggestions = ref(false);
        const selectedPostalCode = ref(null);
        const deliveryAddress = ref({
            rue: "",
            numeroRue: "",
            npa: "",
            localite: "",
        });
        const userAddresses = ref([]);
        const selectedAddressId = ref("");
        const isLoadingAddresses = ref(false);
        const toast = useToast();
        const store = useStore();
        const router = useRouter();
        const route = useRoute();
        const { t } = useI18n();
        const isValidEmail = (email) => {
            if (!email || email.trim() === "")
                return false;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email.trim());
        };
        const getCountryPhonePrefix = () => {
            return selectedCountryCode.value || "+41";
        };
        const parsePhoneForUI = (rawPhone) => {
            if (!rawPhone) {
                return { code: "+41", nationalNumber: "" };
            }
            let cleaned = rawPhone.replace(/\s+/g, "").replace(/-/g, "");
            if (cleaned.startsWith("00")) {
                cleaned = `+${cleaned.slice(2)}`;
            }
            if (cleaned.startsWith("+")) {
                const match = phoneCountryCodes
                    .slice()
                    .sort((a, b) => b.code.length - a.code.length)
                    .find((c) => cleaned.startsWith(c.code));
                if (match) {
                    return {
                        code: match.code,
                        nationalNumber: cleaned.slice(match.code.length),
                    };
                }
                return {
                    code: "+41",
                    nationalNumber: cleaned.replace(/^\+/, ""),
                };
            }
            return { code: "+41", nationalNumber: cleaned };
        };
        const getRestaurantMinOrder = async (codePostal, localite, restaurantID) => {
            try {
                const response = await calculateMinimumAmount(codePostal, localite, restaurantID);
                const minOrder = response?.data?.zone?.minimumOrderAmount || 0;
                const deliveryFee = response?.data?.zone?.deliveryFee || response?.data?.deliveryFee || 0;
                return { minOrder: Number(minOrder), deliveryFee: Number(deliveryFee) };
            }
            catch (error) {
                return { minOrder: 0, deliveryFee: 0 };
            }
        };
        const validateEmail = () => {
            if (customerInfo.value.email && !isValidEmail(customerInfo.value.email)) {
            }
        };
        const getSwissDate = (date) => {
            const now = date || new Date();
            return new Date(now.toLocaleString("en-US", { timeZone: "Europe/Zurich" }));
        };
        const getCurrentTime = () => {
            const swissDate = getSwissDate();
            return swissDate.getHours() * 60 + swissDate.getMinutes();
        };
        const parseTime = (timeString) => {
            const [hours, minutes] = timeString.split(":").map(Number);
            return hours * 60 + minutes;
        };
        const isRestaurantOpen = computed(() => {
            return restaurantInfo.value?.isOpen ?? true;
        });
        const getAvailableTimes = computed(() => {
            if (!restaurantInfo.value?.isOpen) {
                return [];
            }
            const times = [];
            const currentTime = getCurrentTime();
            const selectedDateValue = selectedDate.value;
            for (let hour = 11; hour < 22; hour++) {
                for (let minute = 0; minute < 60; minute += 15) {
                    const timeString = `${hour.toString().padStart(2, "0")}:${minute
                        .toString()
                        .padStart(2, "0")}`;
                    const timeInMinutes = hour * 60 + minute;
                    if (selectedDateValue === getSwissDate().toISOString().split("T")[0]) {
                        if (timeInMinutes > currentTime + 30) {
                            times.push(timeString);
                        }
                    }
                    else {
                        times.push(timeString);
                    }
                }
            }
            return times;
        });
        const getAvailableDates = computed(() => {
            const today = getSwissDate();
            const tomorrow = new Date(today);
            tomorrow.setDate(today.getDate() + 1);
            const dates = [];
            const currentTime = getCurrentTime();
            const isTodayStillValid = currentTime < 21 * 60;
            if (isTodayStillValid) {
                dates.push({
                    value: today.toISOString().split("T")[0],
                    label: `${today.toLocaleDateString("fr-FR", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                    })} - Aujourd'hui`,
                });
            }
            dates.push({
                value: tomorrow.toISOString().split("T")[0],
                label: `${tomorrow.toLocaleDateString("fr-FR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                })} - Demain`,
            });
            return dates;
        });
        const formatDateForPayload = (date, time) => {
            const dateObj = new Date(date);
            return `${dateObj.getDate().toString().padStart(2, "0")}-${(dateObj.getMonth() + 1)
                .toString()
                .padStart(2, "0")}-${dateObj.getFullYear()} ${time}`;
        };
        const selectedFeatures = computed(() => {
            return store?.getters?.["features/selectedFeatures"] || [];
        });
        const discountAmount = computed(() => {
            if (discountType.value === "percentage") {
                if (discountPercentage.value <= 0)
                    return 0;
                const maxDiscount = Math.min(discountPercentage.value, 100);
                return (storeCartTotal.value * maxDiscount) / 100;
            }
            else {
                if (discountFixed.value <= 0)
                    return 0;
                return Math.min(discountFixed.value, storeCartTotal.value);
            }
        });
        const couponDiscountAmount = computed(() => {
            if (appliedCoupons.value.length === 0)
                return 0;
            return appliedCoupons.value.reduce((total, c) => total + (c.discountAmount || 0), 0);
        });
        const canAddMoreCoupons = computed(() => {
            if (appliedCoupons.value.length === 0)
                return true;
            const hasNonStackable = appliedCoupons.value.some(c => !c.coupon?.is_stackable);
            return !hasNonStackable;
        });
        const loadRestaurantMinOrder = async () => {
            if (storeOrderType.value === "delivery" && deliveryAddress.value.npa) {
                const restaurantID = localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID);
                if (restaurantID) {
                    try {
                        const { minOrder, deliveryFee } = await getRestaurantMinOrder(deliveryAddress.value.npa, deliveryAddress.value.localite, restaurantID);
                        restaurantMinOrder.value = minOrder;
                        originalMinOrder.value = minOrder;
                        restaurantDeliveryFee.value = deliveryFee;
                        originalDeliveryFee.value = deliveryFee;
                    }
                    catch (error) {
                        restaurantMinOrder.value = 0;
                        originalMinOrder.value = 0;
                        restaurantDeliveryFee.value = 0;
                        originalDeliveryFee.value = 0;
                    }
                }
            }
        };
        const disableMinOrder = () => {
            restaurantMinOrder.value = 0;
        };
        const enableMinOrder = async () => {
            if (originalMinOrder.value > 0) {
                restaurantMinOrder.value = originalMinOrder.value;
            }
            else {
                await loadRestaurantMinOrder();
            }
        };
        const disableDeliveryFee = () => {
            restaurantDeliveryFee.value = 0;
        };
        const enableDeliveryFee = async () => {
            if (originalDeliveryFee.value > 0) {
                restaurantDeliveryFee.value = originalDeliveryFee.value;
            }
            else {
                await loadRestaurantMinOrder();
            }
        };
        const minOrderSupplement = computed(() => {
            if (storeOrderType.value !== "delivery")
                return 0;
            const subtotalAfterDiscount = storeCartTotal.value - discountAmount.value;
            const totalAfterCoupon = subtotalAfterDiscount - couponDiscountAmount.value;
            const remainingAmount = Math.max(0, restaurantMinOrder.value - totalAfterCoupon);
            return remainingAmount;
        });
        const finalTotalWithCoupon = computed(() => {
            const subtotalAfterDiscount = storeCartTotal.value - discountAmount.value;
            const totalAfterCoupon = subtotalAfterDiscount - couponDiscountAmount.value;
            const totalWithSupplement = totalAfterCoupon + minOrderSupplement.value;
            const totalWithDivers = totalWithSupplement + diversAmount.value;
            const totalWithDelivery = totalWithDivers + restaurantDeliveryFee.value;
            const finalTotal = Math.max(0, totalWithDelivery);
            return finalTotal;
        });
        const orderSummaryWithDiscount = computed(() => {
            const subtotalWithDiscount = storeCartTotal.value - discountAmount.value;
            const subtotalWithDivers = subtotalWithDiscount + diversAmount.value + restaurantDeliveryFee.value;
            const taxOnDiscountedSubtotal = (subtotalWithDivers * taxRate.value) / 100;
            const totalWithDiscount = subtotalWithDiscount;
            return {
                subtotal: storeCartTotal.value,
                tax: taxOnDiscountedSubtotal,
                total: totalWithDiscount,
            };
        });
        const finalTotal = computed(() => {
            return orderSummaryWithDiscount.value.total;
        });
        const paymentMethods = [
            {
                id: "pay_click_collect_cash",
                name: t('pos.cashPayment'),
                icon: "money-bill",
                isSelected: true,
            },
            {
                id: "pay_click_collect_carte",
                name: t('pos.cardPayment'),
                icon: "credit-card",
                isSelected: false,
            },
        ];
        const formatPrice = (price) => {
            const numPrice = typeof price === "string" ? parseFloat(price) : price;
            if (numPrice === undefined || numPrice === null || isNaN(numPrice)) {
                return "0.00";
            }
            return numPrice.toFixed(2);
        };
        const maskEmail = (email) => {
            if (!email || email.trim() === "")
                return "";
            const [localPart, domain] = email.split("@");
            if (!domain)
                return email;
            let maskedLocal = localPart;
            if (localPart.length > 2) {
                maskedLocal =
                    localPart.charAt(0) +
                        "*".repeat(localPart.length - 2) +
                        localPart.charAt(localPart.length - 1);
            }
            const [domainName, extension] = domain.split(".");
            let maskedDomain = domainName;
            if (domainName && domainName.length > 2) {
                maskedDomain =
                    domainName.charAt(0) +
                        "*".repeat(domainName.length - 2) +
                        domainName.charAt(domainName.length - 1);
            }
            return `${maskedLocal}@${maskedDomain}.${extension}`;
        };
        const getCurrentShift = () => {
            const hour = new Date().getHours();
            if (hour >= 6 && hour < 14)
                return "Matin";
            if (hour >= 14 && hour < 22)
                return "Après-midi";
            return "Soir";
        };
        const getInvoiceNumber = () => {
            const now = new Date();
            const timestamp = now.getTime().toString().slice(-6);
            return `${now.getDate().toString().padStart(2, "0")}${(now.getMonth() + 1)
                .toString()
                .padStart(2, "0")}${timestamp}`;
        };
        const hasCustomIngredients = (item) => {
            return item.ingredients.some((ing) => ing.quantity > 0);
        };
        const getCustomIngredients = (item) => {
            return item.ingredients.filter((ing) => ing.quantity > 0);
        };
        const hasRemovedIngredients = (item) => {
            return Boolean(item.removedIngredients && item.removedIngredients.length > 0);
        };
        const getRemovedIngredients = (item) => {
            return item.removedIngredients || [];
        };
        const getPaymentIcon = (iconName) => {
            const iconMap = {
                "money-bill": "💵",
                "credit-card": "💳",
                "mobile-alt": "📱",
            };
            return iconMap[iconName] || "💵";
        };
        const canPlaceOrder = computed(() => {
            const basicValidation = storeCart.value.length > 0 &&
                customerInfo.value.firstName.trim() !== "" &&
                customerInfo.value.lastName.trim() !== "" &&
                customerInfo.value.phone.trim() !== "";
            if (storeOrderType.value === "click_collect" &&
                deliveryPreference.value === "ulterieur") {
                return (basicValidation && selectedDate.value !== "" && selectedTime.value !== "");
            }
            if (storeOrderType.value === "delivery") {
                const deliveryValidation = deliveryAddress.value.rue.trim() !== "" &&
                    deliveryAddress.value.npa.trim() !== "" &&
                    deliveryAddress.value.localite.trim() !== "";
                if (deliveryPreference.value === "ulterieur") {
                    return (basicValidation &&
                        deliveryValidation &&
                        selectedDate.value !== "" &&
                        selectedTime.value !== "");
                }
                return basicValidation && deliveryValidation;
            }
            return basicValidation;
        });
        const loadCustomers = async (searchParams) => {
            try {
                const restaurantID = localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID);
                if (restaurantID) {
                    let searchQuery = "";
                    let searchPhone;
                    if (searchParams?.searchFirstname) {
                        searchQuery = searchParams.searchFirstname;
                    }
                    else if (searchParams?.searchLastname) {
                        searchQuery = searchParams.searchLastname;
                    }
                    else if (searchParams?.searchEmail) {
                        searchQuery = searchParams.searchEmail;
                    }
                    else if (searchParams?.searchTel) {
                        searchPhone = searchParams.searchTel;
                    }
                    const response = await getAllCustomers(1, 50, searchQuery || undefined, searchPhone);
                    if (response.code === 200 && response.data && response.data.data) {
                        allCustomers.value = response.data.data;
                    }
                    else {
                        allCustomers.value = [];
                    }
                }
                else {
                    console.error("❌ RestaurantID non trouvé dans localStorage");
                }
            }
            catch (error) {
                allCustomers.value = [];
            }
        };
        const loadUserAddresses = async (userID) => {
            if (!userID) {
                userAddresses.value = [];
                return;
            }
            isLoadingAddresses.value = true;
            try {
                const response = await getUserAddresses(userID);
                if (response.code === 200 && response?.data?.items) {
                    userAddresses.value = response.data.items;
                }
                else {
                    userAddresses.value = [];
                }
            }
            catch (error) {
                console.error(t('messages.error.loadUserAddressesFailed'), error);
                userAddresses.value = [];
            }
            finally {
                isLoadingAddresses.value = false;
            }
        };
        const handleAddressSelection = (event) => {
            const target = event.target;
            const addressId = target.value;
            if (!addressId) {
                deliveryAddress.value = {
                    rue: "",
                    numeroRue: "",
                    npa: "",
                    localite: "",
                };
                selectedAddressId.value = "";
                selectedPostalCode.value = null;
                return;
            }
            const address = userAddresses.value.find((addr) => addr.id === addressId);
            if (!address)
                return;
            deliveryAddress.value = {
                rue: address.rue || address.address || "",
                numeroRue: address.numeroLocalite === "0" || address.numeroLocalite === null
                    ? ""
                    : address.numeroLocalite || address.numeroRue || "",
                npa: address.codePostal || address.postal_code || "",
                localite: address.localite || address.city || "",
            };
            selectedAddressId.value = addressId;
            selectedPostalCode.value = null;
        };
        const selectCustomer = (customer) => {
            selectedCustomer.value = customer;
            customerInfo.value.id = customer.id;
            customerInfo.value.firstName =
                customer.first_name || customer.firstName || "";
            customerInfo.value.lastName = customer.last_name || customer.lastName || "";
            const rawPhone = customer.phone_number ||
                customer.phoneNumber ||
                customer.phone ||
                customer.tel ||
                customer.user?.phone_number ||
                customer.user?.phoneNumber ||
                "";
            const parsedPhone = parsePhoneForUI(rawPhone);
            selectedCountryCode.value = parsedPhone.code;
            customerInfo.value.phone = parsedPhone.nationalNumber;
            customerInfo.value.email = customer.email || "";
            customerSuggestions.value = [];
            if (customer.listeAdresses && customer.listeAdresses.length > 0) {
                userAddresses.value = customer.listeAdresses;
            }
            else if (customer.user_addresses && customer.user_addresses.length > 0) {
                userAddresses.value = customer.user_addresses;
            }
            else {
                userAddresses.value = [];
            }
        };
        const handleCustomerSearch = () => {
            if (searchTimeout.value) {
                clearTimeout(searchTimeout.value);
            }
            searchTimeout.value = setTimeout(() => {
                searchCustomers();
            }, 300);
        };
        const handleCustomerPhoneSearch = () => {
            if (searchTimeout.value) {
                clearTimeout(searchTimeout.value);
            }
            searchTimeout.value = setTimeout(() => {
                searchCustomers();
            }, 300);
        };
        const searchCustomers = async () => {
            const firstName = customerInfo.value.firstName.trim();
            const lastName = customerInfo.value.lastName.trim();
            const phone = customerInfo.value.phone.trim();
            const email = customerInfo.value.email.trim();
            if (selectedCustomer.value) {
                customerSuggestions.value = [];
                return;
            }
            const hasValidSearch = firstName.length >= 2 ||
                lastName.length >= 2 ||
                phone.length >= 3 ||
                email.length >= 3;
            if (!hasValidSearch) {
                customerSuggestions.value = [];
                return;
            }
            try {
                const searchParams = {};
                if (firstName.length >= 2) {
                    searchParams.searchFirstname = firstName;
                }
                else if (lastName.length >= 2) {
                    searchParams.searchLastname = lastName;
                }
                else if (email.length >= 3) {
                    searchParams.searchEmail = email;
                }
                else if (phone.length >= 3) {
                    searchParams.searchTel = phone.replace(/\D/g, "");
                }
                await loadCustomers(searchParams);
                customerSuggestions.value = allCustomers.value;
            }
            catch (error) {
                console.error("Erreur lors de la recherche de clients:", error);
                customerSuggestions.value = [];
            }
        };
        const loadPosClient = async () => {
            const restaurantID = localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID);
            if (restaurantID) {
                try {
                    const response = await getPosClient(restaurantID);
                    if (response.code === 200 && response.data) {
                        posClient.value = response.data;
                        // Pre-selection of POS client if no customer is currently selected
                        if (!selectedCustomer.value) {
                            selectCustomer(response.data);
                        }
                    }
                }
                catch (error) {
                    console.error("Error loading POS client:", error);
                }
            }
        };
        const initPhoneFromUrl = async () => {
            const phoneParam = route.query.phone || route.query.caller;
            if (!phoneParam)
                return;
            const parsed = parsePhoneForUI(phoneParam);
            selectedCountryCode.value = parsed.code;
            customerInfo.value.phone = parsed.nationalNumber;
            if (route.query.orderType && typeof route.query.orderType === "string") {
                selectedOrderType.value = route.query.orderType;
                store.dispatch("orderType/setOrderType", route.query.orderType);
            }
            // Check Omnesight Caller subscription status set from support_admin
            const callerConfig = restaurantDetails.value?.printer_config?.omnesight_caller;
            if (callerConfig && callerConfig.enabled === false) {
                toast.warning("L'abonnement Omnesight Caller est suspendu pour cet établissement. Veuillez contacter le support.");
                return;
            }
            // Clear default pos client to prioritize caller
            selectedCustomer.value = null;
            try {
                const rawDigits = parsed.nationalNumber.replace(/\D/g, "");
                if (rawDigits.length >= 3) {
                    await loadCustomers({ searchTel: rawDigits });
                    customerSuggestions.value = allCustomers.value;
                    if (allCustomers.value && allCustomers.value.length > 0) {
                        selectCustomer(allCustomers.value[0]);
                    }
                }
            }
            catch (err) {
                console.error("Erreur initPhoneFromUrl:", err);
            }
        };
        const clearSelectedCustomer = () => {
            selectedCustomer.value = null;
            customerInfo.value = {
                id: "",
                firstName: "",
                lastName: "",
                phone: "",
                email: "",
            };
            selectedCountryCode.value = "+41";
            customerSuggestions.value = [];
            userAddresses.value = [];
            selectedAddressId.value = "";
            selectedPostalCode.value = null;
            if (!selectedAddressId.value) {
                deliveryAddress.value = { rue: "", numeroRue: "", npa: "", localite: "" };
                restaurantMinOrder.value = 0;
                originalMinOrder.value = 0;
                restaurantDeliveryFee.value = 0;
                originalDeliveryFee.value = 0;
            }
            else {
                loadRestaurantMinOrder();
            }
        };
        const selectDefaultClient = async (restaurantID) => {
            try {
                const response = await getPosClient(restaurantID);
                if (response && response.code === 200 && response.data) {
                    const posClient = response.data;
                    const customerModel = {
                        id: posClient.id || "",
                        email: posClient.email || "",
                        first_name: posClient.first_name || "",
                        last_name: posClient.last_name || "",
                        phone_number: posClient.phone_number || "",
                        address: posClient.address || "",
                        city: posClient.city || "",
                        postal_code: posClient.postal_code || null,
                        codePostal: posClient.postal_code || "",
                        batiment: posClient.batiment || "",
                        rue: posClient.rue || "",
                        user: null,
                        civilite: posClient.civilite || "monsieur",
                        npa: posClient.npa || "",
                        localite: posClient.localite || "",
                        numeroRue: posClient.numeroRue || null,
                        remarqueCommande: [null, ""],
                        promotions: false,
                        newsletter: false,
                        created_at: new Date().toISOString(),
                    };
                    customerModel.is_pos_client = true;
                    selectCustomer(customerModel);
                }
            }
            catch (error) {
                console.error("Erreur lors de la récupération du client POS par défaut :", error);
            }
        };
        const closeSuggestions = () => {
            customerSuggestions.value = [];
        };
        const getCustomerFirstName = (customer) => {
            if (!customer)
                return "";
            return customer.first_name || customer.firstName || "";
        };
        const getCustomerLastName = (customer) => {
            if (!customer)
                return "";
            return customer.last_name || customer.lastName || "";
        };
        const getCustomerPhone = (customer) => {
            if (!customer)
                return "";
            return customer.phone_number || customer.phoneNumber || "";
        };
        watch(isRestaurantOpen, (newValue) => {
            deliveryPreference.value = newValue ? "immediat" : "ulterieur";
        }, { immediate: false });
        watch(storeOrderType, (newOrderType) => {
            if (newOrderType === "dine_in" && restaurantInfo.value) {
                const restaurantID = localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID);
                if (restaurantID && !selectedCustomer.value) {
                    selectDefaultClient(restaurantID);
                }
            }
            else if (newOrderType !== "dine_in" && selectedCustomer.value) {
                if (selectedCustomer.value.is_pos_client || selectedCustomer.value.email?.startsWith("pos_")) {
                    clearSelectedCustomer();
                }
            }
        }, { immediate: false });
        watch([restaurantInfo, () => store.getters["orderType/selectedOrderType"]], ([restaurant, orderType]) => {
            if (restaurant && orderType === "dine_in" && !selectedCustomer.value) {
                const restaurantID = localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID);
                if (restaurantID) {
                    selectDefaultClient(restaurantID);
                }
            }
        }, { immediate: false });
        watch(storeCart, (newCart, oldCart) => {
            if (oldCart && oldCart.length > 0 && newCart.length > 0) {
                const oldTotal = oldCart.reduce((sum, item) => sum + (item.totalPrice || 0), 0);
                const newTotal = newCart.reduce((sum, item) => sum + (item.totalPrice || 0), 0);
                if (oldTotal !== newTotal) {
                }
            }
        }, { deep: true });
        watch(storeCartTotal, (newSubtotal) => {
            if (discountType.value === "fixed" && discountFixed.value > newSubtotal) {
                discountFixed.value = newSubtotal;
            }
        });
        const updatePricesForOrderType = (newOrderType) => {
            if (storeCart.value.length > 0) {
                const updatedCart = storeCart.value.map((item) => {
                    const totalPrice = calculateItemTotalPrice(item, newOrderType);
                    return {
                        ...item,
                        totalPrice: totalPrice,
                    };
                });
                store.commit("cart/SET_CART", updatedCart);
            }
        };
        watch(selectedOrderType, (newOrderType, oldOrderType) => {
            if (newOrderType !== oldOrderType) {
                store.dispatch("orderType/setOrderType", newOrderType);
                updatePricesForOrderType(newOrderType);
            }
        }, { immediate: false });
        watch([discountAmount, couponDiscountAmount, finalTotalWithCoupon], ([newDiscount, newCoupon, newTotal]) => { });
        watch(() => deliveryAddress.value.npa, (newNpa) => {
            if (storeOrderType.value === "delivery" && newNpa) {
                loadRestaurantMinOrder();
            }
        }, { immediate: false });
        watch(storeOrderType, (newOrderType) => {
            if (newOrderType === "delivery" && deliveryAddress.value.npa) {
                loadRestaurantMinOrder();
            }
            else if (newOrderType !== "delivery") {
                restaurantMinOrder.value = 0;
                restaurantDeliveryFee.value = 0;
                originalMinOrder.value = 0;
                originalDeliveryFee.value = 0;
            }
        }, { immediate: false });
        const loadRestaurantInfo = async () => {
            try {
                const restaurantID = localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID);
                if (restaurantID) {
                    const response = (await detailRestaurant(restaurantID));
                    if (response.code === 200 && response.data) {
                        restaurantInfo.value = response.data;
                        if (response.data.taxValue !== undefined && response.data.taxValue !== null && response.data.taxValue !== '') {
                            taxRate.value = parseFloat(response.data.taxValue);
                        }
                        else if (response.data.franchiseID && response.data.franchiseID.tax_default_rate) {
                            taxRate.value = parseFloat(response.data.franchiseID.tax_default_rate);
                        }
                        else {
                            taxRate.value = 2.6;
                        }
                        if (storeOrderType.value === "dine_in") {
                            selectDefaultClient(restaurantID);
                        }
                    }
                }
            }
            catch (error) {
                console.error(t('messages.error.loadRestaurantInfoFailed'), error);
            }
        };
        const loadRestaurantDetails = async () => {
            try {
                const restaurantID = localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID);
                if (restaurantID) {
                    const response = await getRestaurantDetails(restaurantID);
                    if (response.code === 200 && response.data) {
                        restaurantDetails.value = response.data;
                    }
                }
            }
            catch (error) {
                console.error(t('messages.error.loadRestaurantDetailsFailed'), error);
            }
        };
        const loadAllPostalCodes = async () => {
            try {
                const response = await getAllPostalCodes();
                if (response.code === 200 && response.data) {
                    allPostalCodes.value = response.data;
                }
            }
            catch (error) {
                console.error(t('messages.error.loadPostalCodesFailed'), error);
            }
        };
        const transformCartForAPI = (cart, availableCategories = []) => {
            if (!cart || cart.length === 0) {
                return [];
            }
            const categoriesMap = new Map();
            cart.forEach((item) => {
                if (!item || !item.selectedSize || !item.selectedSize.id) {
                    return;
                }
                let options = [];
                if (item.additionnal && item.additionnal.length > 0) {
                    options = item.additionnal;
                }
                const productFeatures = [];
                const customIngredients = item.ingredients.filter((ing) => !ing.isDefault && ing.quantity > 0);
                customIngredients.forEach((ing) => {
                    productFeatures.push(`${ing.name} (${ing.quantity})`);
                });
                // if (item.supplements && item.supplements.length > 0) {
                //   item.supplements.forEach((supp) => {
                //     if (supp.quantity > 0) {
                //       productFeatures.push(
                //         `${supp.name}${supp.quantity > 1 ? ` (${supp.quantity})` : ""}`
                //       );
                //     }
                //   });
                // }
                const removedIngredientNames = [];
                if (item.removedIngredients && item.removedIngredients.length > 0) {
                    item.removedIngredients.forEach((removedIng) => {
                        removedIngredientNames.push(removedIng);
                    });
                }
                const basePrice = (() => {
                    const dineInPrice = Number(item.selectedSize?.price) || 0;
                    const deliveryPrice = Number(item.selectedSize?.priceLivraison) || 0;
                    if (storeOrderType.value === "delivery") {
                        return deliveryPrice > 0 ? deliveryPrice : dineInPrice;
                    }
                    return dineInPrice > 0 ? dineInPrice : deliveryPrice;
                })();
                const ingredientsPrice = item.ingredients.reduce((total, ing) => {
                    if (!ing.isDefault && ing.quantity > 0) {
                        return total + (Number(ing.extra_cost_price) || 0) * ing.quantity;
                    }
                    return total;
                }, 0);
                const supplementsPrice = item.supplements.reduce((total, supp) => {
                    const supQuantity = supp.quantity || 0;
                    if (supQuantity > 0) {
                        return total + (Number(supp.extra_cost_price) || 0) * supQuantity;
                    }
                    return total;
                }, 0);
                const unitPrice = basePrice + ingredientsPrice + supplementsPrice;
                const productPrice = unitPrice * item.quantity;
                const productData = {
                    id: item.productId,
                    name: item.name,
                    quantity: item.quantity,
                    price: productPrice,
                    specification_id: item.selectedSize.id,
                    size: {
                        id: item.selectedSize.id,
                        name: item.selectedSize.size || item.selectedSize.name || ""
                    },
                    optionSpecific: options.map(opt => ({
                        id: opt.id,
                        name: opt.name
                    })),
                    ingredient: [
                        ...item.ingredients.map((ing) => ({
                            name: ing.name,
                            id: ing.id,
                            extra_cost_price: String(ing.extra_cost_price),
                            isDefault: ing.isDefault,
                            size: ing.size || "",
                            quantite: ing.quantity,
                        })),
                        // ...item.supplements.map((supp) => ({
                        //   name: supp.name,
                        //   extra_cost_price: String(supp.extra_cost_price),
                        //   isDefault: false,
                        //   size: supp.size || "",
                        //   quantite: supp.quantity,
                        // })),
                    ],
                    supplement: [
                        ...item.supplements.map((supp) => ({
                            id: supp.id,
                            name: supp.name,
                            extra_cost_price: String(supp.extra_cost_price),
                            quantite: supp.quantity,
                            type: supp.type,
                        }))
                    ],
                    feature: productFeatures,
                    removedIngredients: removedIngredientNames,
                };
                let categoryName = "Autres";
                let categoryId = "";
                if (item.category) {
                    const foundCategory = availableCategories.find((cat) => cat.id === item.category);
                    categoryName = foundCategory ? foundCategory.name : "Autres";
                    categoryId = foundCategory ? foundCategory.id : "";
                }
                if (!categoriesMap.has(categoryName)) {
                    categoriesMap.set(categoryName, { id: categoryId, products: [] });
                }
                categoriesMap.get(categoryName).products.push(productData);
            });
            const categoriesResult = Array.from(categoriesMap.entries()).map(([categoryName, categoryData]) => ({
                category: categoryName,
                category_id: categoryData.id,
                products: categoryData.products,
            }));
            return categoriesResult;
        };
        const extractFeaturesFromCart = (cart) => {
            const features = [];
            const storeFeatures = store?.getters?.["features/selectedFeatures"] || [];
            features.push(...storeFeatures);
            cart.forEach((item) => {
                if (item.additionnal && item.additionnal.length > 0) {
                    features.push(...item.additionnal.map(opt => typeof opt === 'string' ? opt : opt.name));
                }
            });
            return [...new Set(features)];
        };
        const handlePlaceOrder = async () => {
            if (!canPlaceOrder.value || isProcessingOrder.value)
                return;
            isProcessingOrder.value = true;
            try {
                const restaurantID = localStorage.getItem(UserGeneralKey.USER_RESTAURANT_ID);
                if (!restaurantID || !restaurantInfo.value) {
                    toast.error(t('messages.error.restaurantInfoMissing'));
                    isProcessingOrder.value = false;
                    return;
                }
                if (!customerInfo.value.phone) {
                    toast.error(t('messages.error.fillAllFields'));
                    isProcessingOrder.value = false;
                    return;
                }
                const cartFeatures = extractFeaturesFromCart(storeCart.value);
                const customerID = selectedCustomer.value?.id || customerInfo.value.id;
                const formatPhoneNumber = (phone) => {
                    const phoneNumber = phone?.trim() || "";
                    if (!phoneNumber)
                        return "";
                    const prefix = getCountryPhonePrefix();
                    if (phoneNumber.startsWith(prefix)) {
                        return phoneNumber;
                    }
                    const prefixWithoutPlus = prefix.substring(1);
                    if (phoneNumber.startsWith(prefixWithoutPlus)) {
                        return prefix + phoneNumber.substring(prefixWithoutPlus.length);
                    }
                    return prefix + phoneNumber;
                };
                const generateUniqueEmail = () => {
                    const timestamp = Date.now();
                    const randomId = Math.random().toString(36).substring(2, 8);
                    const restaurantSuffix = restaurantID === "fd9d1677-f994-473a-9939-908cf3145bd4"
                        ? "morges"
                        : "penthaz";
                    return `guest_${timestamp}_${randomId}@${restaurantSuffix}.dummy.com`;
                };
                const renderEmail = () => {
                    const defaultEmail = selectedCustomer.value?.email || customerInfo.value.email || "";
                    if (defaultEmail && isValidEmail(defaultEmail)) {
                        return defaultEmail;
                    }
                    return generateUniqueEmail();
                };
                const orderData = {
                    coupon: appliedCoupons.value[0]?.code || "",
                    couponValue: String(appliedCoupons.value[0]?.discount || "0"),
                    couponType: appliedCoupons.value[0]?.coupon?.discount_type || "",
                    appliedCoupons: appliedCoupons.value.map(c => ({ code: c.code })),
                    codePostal: storeOrderType.value === "delivery"
                        ? `${deliveryAddress.value.npa}`.trim()
                        : restaurantInfo.value?.codePostalID?.numeroPostal,
                    deliveryLocality: storeOrderType.value === "delivery"
                        ? ` ${deliveryAddress.value.localite}`.trim()
                        : restaurantInfo.value?.codePostalID?.ville,
                    restaurantID: restaurantID,
                    paniers: transformCartForAPI(storeCart.value, props.categories || []),
                    userID: selectedCustomer.value?.user?.id || posClient.value?.id || "",
                    civilite: selectedCustomer.value?.civilite || posClient.value?.civilite || "monsieur",
                    guest_first_name: customerInfo.value.firstName,
                    guest_last_name: customerInfo.value.lastName,
                    guest_email: renderEmail(),
                    guest_phone_number: formatPhoneNumber(selectedCustomer?.value?.phone_number ||
                        selectedCustomer?.value?.phoneNumber ||
                        customerInfo.value.phone),
                    order_type: storeOrderType.value,
                    numberRue: storeOrderType.value === "delivery"
                        ? deliveryAddress.value.numeroRue
                        : restaurantInfo.value?.numeroRue || "",
                    deliveryPreference: deliveryPreference.value,
                    typeCustomer: clientType.value,
                    timeOrder: deliveryPreference.value === "ulterieur" &&
                        selectedDate.value &&
                        selectedTime.value
                        ? formatDateForPayload(selectedDate.value, selectedTime.value)
                        : "",
                    payment_method: selectedPaymentMethod.value,
                    addressLivraison: storeOrderType.value === "delivery"
                        ? `${deliveryAddress.value.rue} ${deliveryAddress.value.numeroRue}`.trim()
                        : `${restaurantInfo.value?.address || ""}`,
                    batiment: restaurantInfo.value?.batiment || "",
                    rue: storeOrderType.value === "delivery"
                        ? deliveryAddress.value.rue
                        : restaurantInfo.value?.address || "",
                    npa: storeOrderType.value === "delivery"
                        ? deliveryAddress.value.npa
                        : restaurantInfo.value?.codePostalID?.numeroPostal || "",
                    localite: storeOrderType.value === "delivery"
                        ? deliveryAddress.value.localite
                        : restaurantInfo.value?.codePostalID?.ville || "",
                    societe: organisationInfo.value.societe || "",
                    departement: organisationInfo.value.departement || "",
                    newsletter: "0",
                    discount: discountType.value === "percentage"
                        ? discountPercentage.value > 0
                            ? discountPercentage.value.toString()
                            : "0"
                        : "0",
                    discountFixed: discountType.value === "fixed"
                        ? discountFixed.value > 0
                            ? discountFixed.value.toString()
                            : "0"
                        : "0",
                    discountType: discountType.value,
                    discountValue: discountType.value === "percentage"
                        ? String(discountPercentage.value)
                        : String(discountFixed.value),
                    discountAmount: discountAmount.value > 0 ? discountAmount.value.toString() : "0",
                    divers: diversAmount.value > 0 ? diversAmount.value.toString() : "0",
                    tvaAmount: formatPrice((storeCartTotal.value * taxRate.value) / 100) || "0",
                    SpecialInstructions: SpecialInstructions.value,
                    intructionOrder: [
                        {
                            demandeCouverts: false,
                            quantityCouverts: "0",
                            delaiRecuperation: "00:00",
                            isTrancher: isTrancher.value,
                            cuisson: "Normal",
                        },
                    ],
                    additional_fees: [
                        {
                            type: storeOrderType.value,
                            amount: minOrderSupplement.value,
                        },
                    ],
                    deliveryFee: restaurantDeliveryFee.value > 0 ? Number(restaurantDeliveryFee.value) : 0,
                    subtotal: storeCartTotal.value,
                    total: finalTotalWithCoupon.value,
                    platform: "POS",
                };
                const response = await createPOSOrder(orderData);
                if (response.code === 200 || response.code === 201) {
                    toast.success(t('pos.orderCreatedSuccess'));
                    if (store) {
                        store.dispatch("cart/clearCart");
                        store.dispatch("features/clearFeatures");
                    }
                    customerInfo.value = {
                        id: "",
                        firstName: "",
                        lastName: "",
                        phone: "",
                        email: "",
                    };
                    selectedCustomer.value = null;
                    customerSuggestions.value = [];
                    deliveryPreference.value = isRestaurantOpen.value
                        ? "immediat"
                        : "ulterieur";
                    selectedDate.value = "";
                    selectedTime.value = "";
                    discountType.value = "percentage";
                    discountPercentage.value = 0;
                    discountFixed.value = 0;
                    diversAmount.value = 0;
                    appliedCoupons.value = [];
                    couponCode.value = "";
                    deliveryAddress.value = { rue: "", numeroRue: "", npa: "", localite: "" };
                    emit("place-order", { success: true, orderData: response.data });
                    window.location.reload();
                }
                else {
                    toast.error(response.message || t('pos.orderCreationError'));
                }
            }
            catch (error) {
                console.error("Erreur lors de la création de la commande:", error);
                console.error("Stack trace:", error?.stack);
                if (error?.response) {
                    const errorMessage = error?.response?.data?.message ||
                        error?.response?.data?.error ||
                        `Erreur API: ${error?.response?.status} ${error?.response?.statusText}`;
                    toast.error(errorMessage);
                }
                else if (error?.message) {
                    toast.error(`Erreur: ${error.message}`);
                }
                else {
                    toast.error(t('pos.orderCreationError') + ". " + t('messages.error.generic'));
                }
            }
            finally {
                isProcessingOrder.value = false;
            }
        };
        const decreaseQuantity = (itemId) => {
            const item = storeCart.value.find((item) => item.localProductId === itemId);
            if (item) {
                emit("update-quantity", itemId, item.quantity - 1);
            }
        };
        const increaseQuantity = (itemId) => {
            const item = storeCart.value.find((item) => item.localProductId === itemId);
            if (item) {
                emit("update-quantity", itemId, item.quantity + 1);
            }
        };
        const removeItem = (itemId) => {
            emit("remove-item", itemId);
        };
        const selectPaymentMethod = (methodId) => {
            selectedPaymentMethod.value = methodId;
        };
        const handleDiscountTypeChange = () => {
            if (discountType.value === "percentage") {
                discountFixed.value = 0;
            }
            else {
                discountPercentage.value = 0;
            }
        };
        const handleDiscountChange = () => {
            if (discountPercentage.value < 0) {
                discountPercentage.value = 0;
            }
            else if (discountPercentage.value > 100) {
                discountPercentage.value = 100;
            }
        };
        const handleFixedDiscountChange = () => {
            if (discountFixed.value < 0) {
                discountFixed.value = 0;
            }
            if (discountFixed.value > storeCartTotal.value) {
                discountFixed.value = storeCartTotal.value;
            }
        };
        const handleDiversChange = () => {
            if (diversAmount.value < 0) {
                diversAmount.value = 0;
            }
        };
        const applyCouponCode = async () => {
            if (!canAddMoreCoupons.value) {
                toast.error("Un coupon non cumulable est déjà appliqué. Impossible d'en ajouter d'autres.");
                return;
            }
            const cleanCode = couponCode.value.trim();
            if (!cleanCode) {
                toast.error(t('messages.error.enterPromoCode'));
                return;
            }
            if (appliedCoupons.value.some(c => c.code.toLowerCase() === cleanCode.toLowerCase())) {
                toast.info("Ce code promo est déjà appliqué.");
                return;
            }
            isApplyingCoupon.value = true;
            try {
                const response = await applyCoupon({
                    coupon: cleanCode,
                    email: selectedCustomer.value?.email || customerInfo.value.email || "",
                    amount: String(storeCartTotal.value),
                });
                if (response.code === 200) {
                    const couponData = {
                        ...response.data,
                        code: response.data.coupon?.code || cleanCode,
                        discountAmount: parseFloat(response.data?.discount || "0") || 0,
                    };
                    // Validation de la cumulabilité
                    if (appliedCoupons.value.length > 0 && !couponData.coupon?.is_stackable) {
                        toast.error("Ce coupon n'est pas cumulable avec les codes déjà appliqués.");
                        return;
                    }
                    appliedCoupons.value.push(couponData);
                    couponCode.value = "";
                    toast.success(response.message);
                }
                else {
                    toast.error(response.message || "Code promo invalide");
                }
            }
            catch (error) {
                toast.error(t('messages.error.invalidPromoCode'));
            }
            finally {
                isApplyingCoupon.value = false;
            }
        };
        const removeCoupon = (code) => {
            appliedCoupons.value = appliedCoupons.value.filter(c => c.code !== code);
            toast.info(t('messages.success.couponRemoved'));
        };
        const searchPostalCodes = (query) => {
            if (!query.trim() || query.length < 2) {
                postalCodeSuggestions.value = [];
                showPostalCodeSuggestions.value = false;
                return;
            }
            const results = allPostalCodes.value
                .filter((postalCode) => {
                if (!postalCode)
                    return false;
                const postalCodeStr = String(postalCode.code ||
                    postalCode.numeroPostal ||
                    postalCode.postal_code ||
                    "");
                const cityStr = String(postalCode.locality ||
                    postalCode.ville ||
                    postalCode.city ||
                    postalCode.localite ||
                    "");
                const matches = postalCodeStr.includes(query) ||
                    cityStr.toLowerCase().includes(query.toLowerCase());
                return matches;
            })
                .slice(0, 10);
            postalCodeSuggestions.value = results;
            showPostalCodeSuggestions.value = results.length > 0;
        };
        const selectPostalCode = (postalCode) => {
            selectedPostalCode.value = postalCode;
            const postalCodeStr = String(postalCode.code || postalCode.numeroPostal || postalCode.postal_code || "");
            const cityStr = String(postalCode.locality ||
                postalCode.ville ||
                postalCode.city ||
                postalCode.localite ||
                "");
            deliveryAddress.value.npa = postalCodeStr;
            deliveryAddress.value.localite = cityStr;
            showPostalCodeSuggestions.value = false;
            postalCodeSuggestions.value = [];
            if (storeOrderType.value === "delivery") {
                loadRestaurantMinOrder();
            }
        };
        const handlePostalCodeChange = () => {
            if (selectedPostalCode.value) {
                const postalCodeStr = String(selectedPostalCode.value.code ||
                    selectedPostalCode.value.numeroPostal ||
                    selectedPostalCode.value.postal_code ||
                    "");
                if (deliveryAddress.value.npa !== postalCodeStr) {
                    selectedPostalCode.value = null;
                }
            }
            searchPostalCodes(deliveryAddress.value.npa);
        };
        const handleDateChange = () => {
            if (selectedTime.value) {
                const availableTimes = getAvailableTimes.value;
                if (!availableTimes.includes(selectedTime.value)) {
                    selectedTime.value = "";
                }
            }
        };
        watch(storeOrderType, (newOrderType, oldOrderType) => {
            if (newOrderType !== oldOrderType) {
                storeCart.value.forEach((item, index) => { });
                store.dispatch("cart/recalculateAllPrices");
            }
        }, { immediate: false });
        const cartItemsWithCorrectPrices = computed(() => {
            const orderType = storeOrderType.value;
            if (!storeCart.value || storeCart.value.length === 0) {
                return [];
            }
            return storeCart.value.map((item) => {
                if (!item || !item.selectedSize) {
                    return item;
                }
                const totalPrice = calculateItemTotalPrice(item, orderType);
                return {
                    ...item,
                    totalPrice: totalPrice,
                    calculatedPrice: totalPrice,
                    calculatedTotalPrice: totalPrice * item.quantity,
                };
            });
        });
        const validCartItems = computed(() => {
            return cartItemsWithCorrectPrices.value.filter((item) => item && item.localProductId);
        });
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[40] || (_cache[40] = _createElementVNode("div", { class: "invoice-header" }, null, -1)),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(t)('pos.customerInfo')), 1),
                    (selectedCustomer.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _cache[28] || (_cache[28] = _createElementVNode("span", { class: "banner-icon" }, "👤", -1)),
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('pos.registeredCustomerSelected')), 1),
                                    _createElementVNode("span", _hoisted_8, _toDisplayString(getCustomerFirstName(selectedCustomer.value)) + " " + _toDisplayString(getCustomerLastName(selectedCustomer.value)), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                                (selectedCustomer.value.id)
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 0,
                                        to: `/customer/edit/${selectedCustomer.value.id}`,
                                        class: "banner-edit-link",
                                        target: "_blank"
                                    }, {
                                        default: _withCtx(() => [
                                            _cache[29] || (_cache[29] = _createElementVNode("i", { class: "fas fa-edit" }, null, -1)),
                                            _createTextVNode(" " + _toDisplayString(_unref(t)('common.edit')), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["to"]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("button", {
                                    onClick: clearSelectedCustomer,
                                    class: "banner-clear-btn"
                                }, [
                                    _cache[30] || (_cache[30] = _createElementVNode("i", { class: "fas fa-times" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_unref(t)('pos.deselect')), 1)
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("label", null, _toDisplayString(_unref(t)('pos.firstName')), 1),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((customerInfo.value.firstName) = $event)),
                                type: "text",
                                placeholder: _unref(t)('pos.firstNamePlaceholder'),
                                class: _normalizeClass(['form-input', { 'client-selected': selectedCustomer.value }]),
                                onInput: handleCustomerSearch
                            }, null, 42, _hoisted_12), [
                                [_vModelText, customerInfo.value.firstName]
                            ]),
                            (customerSuggestions.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customerSuggestions.value, (customer) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: customer.id,
                                            class: "customer-suggestion",
                                            onClick: ($event) => (selectCustomer(customer))
                                        }, [
                                            _createElementVNode("div", _hoisted_15, [
                                                _createElementVNode("span", _hoisted_16, _toDisplayString(getCustomerFirstName(customer)) + " " + _toDisplayString(getCustomerLastName(customer)), 1),
                                                _createElementVNode("span", _hoisted_17, _toDisplayString(getCustomerPhone(customer)), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_18, _toDisplayString(customer.email), 1)
                                        ], 8, _hoisted_14));
                                    }), 128))
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("label", null, _toDisplayString(_unref(t)('pos.lastName')), 1),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((customerInfo.value.lastName) = $event)),
                                type: "text",
                                placeholder: _unref(t)('pos.lastNamePlaceholder'),
                                class: _normalizeClass(['form-input', { 'client-selected': selectedCustomer.value }]),
                                onInput: handleCustomerSearch
                            }, null, 42, _hoisted_20), [
                                [_vModelText, customerInfo.value.lastName]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("label", null, _toDisplayString(_unref(t)('pos.phone')), 1),
                            _createElementVNode("div", _hoisted_22, [
                                _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((selectedCountryCode).value = $event)),
                                    class: "country-prefix-select"
                                }, [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(phoneCountryCodes, (country) => {
                                        return _createElementVNode("option", {
                                            key: country.code,
                                            value: country.code
                                        }, _toDisplayString(country.flag) + " " + _toDisplayString(country.prefix), 9, _hoisted_23);
                                    }), 64))
                                ], 512), [
                                    [_vModelSelect, selectedCountryCode.value]
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((customerInfo.value.phone) = $event)),
                                    type: "tel",
                                    placeholder: _unref(t)('pos.phonePlaceholder'),
                                    class: _normalizeClass([
                                        'form-input',
                                        'phone-input',
                                        { 'client-selected': selectedCustomer.value },
                                    ]),
                                    onInput: handleCustomerPhoneSearch
                                }, null, 42, _hoisted_24), [
                                    [_vModelText, customerInfo.value.phone]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("label", null, _toDisplayString(_unref(t)('pos.email')), 1),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((customerInfo.value.email) = $event)),
                                type: "email",
                                placeholder: _unref(t)('pos.emailPlaceholder'),
                                required: "",
                                class: _normalizeClass([
                                    'form-input',
                                    {
                                        'client-selected': selectedCustomer.value,
                                        'invalid-email': customerInfo.value.email && !isValidEmail(customerInfo.value.email),
                                    },
                                ]),
                                onInput: handleCustomerSearch,
                                onBlur: validateEmail
                            }, null, 42, _hoisted_26), [
                                [_vModelText, customerInfo.value.email]
                            ]),
                            (customerInfo.value.email && !isValidEmail(customerInfo.value.email))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_unref(t)('pos.invalidEmail')), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("label", null, _toDisplayString(_unref(t)('pos.orderType')), 1),
                            _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((selectedOrderType).value = $event)),
                                class: "form-select"
                            }, [
                                _createElementVNode("option", _hoisted_29, _toDisplayString(_unref(t)('pos.orderTypeDineIn')), 1),
                                _createElementVNode("option", _hoisted_30, _toDisplayString(_unref(t)('pos.orderTypeClickCollect')), 1),
                                _createElementVNode("option", _hoisted_31, _toDisplayString(_unref(t)('pos.orderTypeDelivery')), 1)
                            ], 512), [
                                [_vModelSelect, selectedOrderType.value]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("label", null, _toDisplayString(_unref(t)('pos.clientType')), 1),
                            _createElementVNode("div", _hoisted_33, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "radio",
                                    name: "customer",
                                    id: "customer",
                                    value: "customer",
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((clientType).value = $event))
                                }, null, 512), [
                                    [_vModelRadio, clientType.value]
                                ]),
                                _createElementVNode("label", _hoisted_34, _toDisplayString(_unref(t)('pos.clientTypeCustomer')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "radio",
                                    name: "organisation",
                                    id: "organisation",
                                    value: "organisation",
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((clientType).value = $event))
                                }, null, 512), [
                                    [_vModelRadio, clientType.value]
                                ]),
                                _createElementVNode("label", _hoisted_36, _toDisplayString(_unref(t)('pos.clientTypeOrganisation')), 1)
                            ])
                        ]),
                        (clientType.value === 'organisation')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                _createElementVNode("div", _hoisted_38, [
                                    _createElementVNode("label", null, _toDisplayString(_unref(t)('pos.company')), 1),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((organisationInfo.value.societe) = $event)),
                                        type: "text",
                                        placeholder: _unref(t)('pos.companyPlaceholder'),
                                        class: _normalizeClass(['form-input', { 'client-selected': selectedCustomer.value }]),
                                        onInput: handleCustomerSearch
                                    }, null, 42, _hoisted_39), [
                                        [_vModelText, organisationInfo.value.societe]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_40, [
                                    _createElementVNode("label", null, _toDisplayString(_unref(t)('pos.department')), 1),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((organisationInfo.value.departement) = $event)),
                                        type: "text",
                                        placeholder: _unref(t)('pos.departmentPlaceholder'),
                                        class: _normalizeClass(['form-input', { 'client-selected': selectedCustomer.value }]),
                                        onInput: handleCustomerSearch
                                    }, null, 42, _hoisted_41), [
                                        [_vModelText, organisationInfo.value.departement]
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (storeOrderType.value === 'click_collect' || storeOrderType.value === 'delivery')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                _createElementVNode("label", null, _toDisplayString(_unref(t)('pos.pickupTime')), 1),
                                _createElementVNode("div", _hoisted_43, [
                                    _createElementVNode("div", _hoisted_44, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "radio",
                                            id: "immediat",
                                            name: "deliveryPreference",
                                            value: "immediat",
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((deliveryPreference).value = $event)),
                                            disabled: !isRestaurantOpen.value
                                        }, null, 8, _hoisted_45), [
                                            [_vModelRadio, deliveryPreference.value]
                                        ]),
                                        _createElementVNode("label", _hoisted_46, [
                                            _createElementVNode("span", _hoisted_47, _toDisplayString(_unref(t)('pos.asSoonAsPossible')), 1),
                                            (!isRestaurantOpen.value)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_unref(t)('pos.restaurantClosed')), 1))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_unref(t)('pos.readyInMinutes')), 1))
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_50, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "radio",
                                            id: "ulterieur",
                                            name: "deliveryPreference",
                                            value: "ulterieur",
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((deliveryPreference).value = $event))
                                        }, null, 512), [
                                            [_vModelRadio, deliveryPreference.value]
                                        ]),
                                        _createElementVNode("label", _hoisted_51, [
                                            _createElementVNode("span", _hoisted_52, _toDisplayString(_unref(t)('pos.scheduledDateTime')), 1),
                                            _createElementVNode("span", _hoisted_53, _toDisplayString(_unref(t)('pos.scheduleForLater')), 1)
                                        ])
                                    ])
                                ]),
                                (deliveryPreference.value === 'ulterieur')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                        _createElementVNode("div", _hoisted_55, [
                                            _createElementVNode("label", null, _toDisplayString(_unref(t)('pos.pickupDate')), 1),
                                            _withDirectives(_createElementVNode("select", {
                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((selectedDate).value = $event)),
                                                class: "form-select",
                                                onChange: handleDateChange
                                            }, [
                                                _createElementVNode("option", _hoisted_56, _toDisplayString(_unref(t)('pos.selectDate')), 1),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getAvailableDates.value, (date) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        key: date.value,
                                                        value: date.value
                                                    }, _toDisplayString(date.label), 9, _hoisted_57));
                                                }), 128))
                                            ], 544), [
                                                [_vModelSelect, selectedDate.value]
                                            ])
                                        ]),
                                        (selectedDate.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                                _createElementVNode("label", null, _toDisplayString(_unref(t)('pos.pickupTimeHour')), 1),
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((selectedTime).value = $event)),
                                                    class: "form-select"
                                                }, [
                                                    _createElementVNode("option", _hoisted_59, _toDisplayString(_unref(t)('pos.selectTime')), 1),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getAvailableTimes.value, (time) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: time,
                                                            value: time
                                                        }, _toDisplayString(time), 9, _hoisted_60));
                                                    }), 128))
                                                ], 512), [
                                                    [_vModelSelect, selectedTime.value]
                                                ]),
                                                (selectedDate.value === getSwissDate().toISOString().split('T')[0] &&
                                                    getAvailableTimes.value.length === 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                                        _createElementVNode("span", _hoisted_62, _toDisplayString(_unref(t)('pos.noTimeAvailableToday')), 1)
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true),
                        (storeOrderType.value === 'delivery')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                _createElementVNode("h4", _hoisted_64, _toDisplayString(_unref(t)('pos.deliveryAddress')), 1),
                                (selectedCustomer.value && userAddresses.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                        _createElementVNode("label", null, _toDisplayString(_unref(t)('pos.savedAddresses')), 1),
                                        _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((selectedAddressId).value = $event)),
                                            class: "form-select",
                                            onChange: handleAddressSelection
                                        }, [
                                            _createElementVNode("option", _hoisted_66, _toDisplayString(_unref(t)('pos.newAddress')), 1),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userAddresses.value, (address) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: address.id,
                                                    value: address.id
                                                }, _toDisplayString(address.rue || address.address) + " " + _toDisplayString(address.numeroLocalite || address.numeroRue) + ", " + _toDisplayString(address.localite || address.city), 9, _hoisted_67));
                                            }), 128))
                                        ], 544), [
                                            [_vModelSelect, selectedAddressId.value]
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_68, [
                                    _createElementVNode("label", null, _toDisplayString(_unref(t)('pos.postalCode')), 1),
                                    _createElementVNode("div", _hoisted_69, [
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((deliveryAddress.value.npa) = $event)),
                                            type: "text",
                                            placeholder: _unref(t)('pos.postalCodePlaceholder'),
                                            class: "form-input",
                                            disabled: selectedAddressId.value !== '' && userAddresses.value.length > 0,
                                            onInput: handlePostalCodeChange,
                                            onFocus: handlePostalCodeChange
                                        }, null, 40, _hoisted_70), [
                                            [_vModelText, deliveryAddress.value.npa]
                                        ]),
                                        (showPostalCodeSuggestions.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(postalCodeSuggestions.value, (postalCode) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: postalCode.code,
                                                        class: "postal-code-suggestion",
                                                        onClick: ($event) => (selectPostalCode(postalCode))
                                                    }, [
                                                        _createElementVNode("span", _hoisted_73, _toDisplayString(postalCode.code), 1),
                                                        _createElementVNode("span", _hoisted_74, _toDisplayString(postalCode.locality), 1)
                                                    ], 8, _hoisted_72));
                                                }), 128))
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_75, [
                                    _createElementVNode("label", null, _toDisplayString(_unref(t)('pos.locality')), 1),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((deliveryAddress.value.localite) = $event)),
                                        type: "text",
                                        placeholder: _unref(t)('pos.localityPlaceholder'),
                                        class: "form-input",
                                        disabled: selectedAddressId.value !== '' && userAddresses.value.length > 0
                                    }, null, 8, _hoisted_76), [
                                        [_vModelText, deliveryAddress.value.localite]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_77, [
                                    _createElementVNode("label", null, _toDisplayString(_unref(t)('pos.street')), 1),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((deliveryAddress.value.rue) = $event)),
                                        type: "text",
                                        placeholder: _unref(t)('pos.streetPlaceholder'),
                                        class: "form-input",
                                        disabled: selectedAddressId.value !== '' && userAddresses.value.length > 0
                                    }, null, 8, _hoisted_78), [
                                        [_vModelText, deliveryAddress.value.rue]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_79, [
                                    _createElementVNode("label", null, _toDisplayString(_unref(t)('pos.streetNumber')), 1),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((deliveryAddress.value.numeroRue) = $event)),
                                        type: "text",
                                        placeholder: _unref(t)('pos.streetNumberPlaceholder'),
                                        class: "form-input",
                                        disabled: selectedAddressId.value !== '' && userAddresses.value.length > 0
                                    }, null, 8, _hoisted_80), [
                                        [_vModelText, deliveryAddress.value.numeroRue]
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("h3", _hoisted_83, _toDisplayString(_unref(t)('pos.order')), 1),
                            _createElementVNode("span", _hoisted_84, _toDisplayString(cartItemsWithCorrectPrices.value?.length || 0) + " " + _toDisplayString(_unref(t)('pos.items')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_85, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validCartItems.value, (item) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: item?.localProductId || item?.id,
                                    class: "cart-item"
                                }, [
                                    _createElementVNode("div", _hoisted_86, [
                                        _createElementVNode("img", {
                                            src: item.image,
                                            alt: item.name
                                        }, null, 8, _hoisted_87)
                                    ]),
                                    _createElementVNode("div", _hoisted_88, [
                                        _createElementVNode("h4", _hoisted_89, _toDisplayString(item.name), 1),
                                        _createElementVNode("p", _hoisted_90, _toDisplayString(item.selectedSize?.size), 1),
                                        (hasCustomIngredients(item))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                                _createElementVNode("span", _hoisted_92, _toDisplayString(_unref(t)('pos.customized')), 1),
                                                _createElementVNode("div", _hoisted_93, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getCustomIngredients(item), (ingredient) => {
                                                        return (_openBlock(), _createElementBlock("span", {
                                                            key: ingredient.id,
                                                            class: "ingredient-tag"
                                                        }, _toDisplayString(ingredient.name) + " (" + _toDisplayString(ingredient.quantity) + ") ", 1));
                                                    }), 128))
                                                ])
                                            ]))
                                            : _createCommentVNode("", true),
                                        (hasRemovedIngredients(item))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                                _createElementVNode("span", _hoisted_95, _toDisplayString(_unref(t)('pos.removed')), 1),
                                                _createElementVNode("div", _hoisted_96, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getRemovedIngredients(item), (ingredient) => {
                                                        return (_openBlock(), _createElementBlock("span", {
                                                            key: ingredient.id,
                                                            class: "ingredient-tag removed-ingredient"
                                                        }, _toDisplayString(ingredient.name) + " (" + _toDisplayString(ingredient.quantity) + ") ", 1));
                                                    }), 128))
                                                ])
                                            ]))
                                            : _createCommentVNode("", true),
                                        (item.additionnal && item.additionnal.length)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                                _createElementVNode("span", _hoisted_98, _toDisplayString(_unref(t)('pos.options')), 1),
                                                _createElementVNode("div", _hoisted_99, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.additionnal, (option) => {
                                                        return (_openBlock(), _createElementBlock("span", {
                                                            key: option,
                                                            class: "ingredient-tag"
                                                        }, _toDisplayString(option.name), 1));
                                                    }), 128))
                                                ])
                                            ]))
                                            : _createCommentVNode("", true),
                                        (item.supplements && item.supplements.length)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                                _createElementVNode("span", _hoisted_101, _toDisplayString(_unref(t)('pos.supplements')), 1),
                                                _createElementVNode("div", _hoisted_102, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.supplements, (supp) => {
                                                        return (_openBlock(), _createElementBlock("span", {
                                                            key: supp.id,
                                                            class: "ingredient-tag"
                                                        }, [
                                                            _createTextVNode(_toDisplayString(supp.name), 1),
                                                            (supp.quantity > 1)
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                    _createTextVNode(" (" + _toDisplayString(supp.quantity) + ")", 1)
                                                                ], 64))
                                                                : _createCommentVNode("", true)
                                                        ]));
                                                    }), 128))
                                                ])
                                            ]))
                                            : _createCommentVNode("", true),
                                        (item.notes)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_103, _toDisplayString(item.notes), 1))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_104, [
                                        _createElementVNode("div", _hoisted_105, [
                                            _createElementVNode("button", {
                                                class: "qty-btn decrease",
                                                onClick: ($event) => (decreaseQuantity(item.localProductId))
                                            }, " ➖ ", 8, _hoisted_106),
                                            _createElementVNode("span", _hoisted_107, _toDisplayString(item.quantity), 1),
                                            _createElementVNode("button", {
                                                class: "qty-btn increase",
                                                onClick: ($event) => (increaseQuantity(item.localProductId))
                                            }, " ➕ ", 8, _hoisted_108)
                                        ]),
                                        _createElementVNode("div", _hoisted_109, [
                                            _createElementVNode("span", _hoisted_110, _toDisplayString(formatPrice(item.calculatedTotalPrice || item.totalPrice)) + " CHF", 1)
                                        ]),
                                        _createElementVNode("button", {
                                            class: "remove-btn",
                                            onClick: ($event) => (removeItem(item.localProductId))
                                        }, " 🗑️ ", 8, _hoisted_111)
                                    ])
                                ]));
                            }), 128)),
                            (!validCartItems.value || validCartItems.value.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                                    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "empty-icon" }, null, -1)),
                                    _createElementVNode("p", null, _toDisplayString(_unref(t)('pos.emptyCart')), 1),
                                    _createElementVNode("span", null, _toDisplayString(_unref(t)('pos.addItemsToStart')), 1)
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    (storeCart.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                            _createElementVNode("h3", _hoisted_114, _toDisplayString(_unref(t)('pos.summary')), 1),
                            _createElementVNode("div", _hoisted_115, [
                                _createElementVNode("h4", _hoisted_116, _toDisplayString(_unref(t)('pos.promoCode')), 1),
                                (storeOrderType.value === 'delivery' && restaurantMinOrder.value > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                                        _createElementVNode("div", _hoisted_118, [
                                            _cache[32] || (_cache[32] = _createElementVNode("span", { class: "min-order-icon" }, "ℹ️", -1)),
                                            _createElementVNode("span", _hoisted_119, [
                                                _createTextVNode(_toDisplayString(_unref(t)('pos.minimumOrderAmount')), 1),
                                                _createElementVNode("strong", null, _toDisplayString(formatPrice(restaurantMinOrder.value)) + " CHF", 1),
                                                (minOrderSupplement.value > 0)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_120, " (supplément de " + _toDisplayString(formatPrice(minOrderSupplement.value)) + " CHF appliqué) ", 1))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (appliedCoupons.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appliedCoupons.value, (coupon) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: coupon.code,
                                                class: "applied-coupon mb-2"
                                            }, [
                                                _createElementVNode("div", _hoisted_122, [
                                                    _createElementVNode("span", _hoisted_123, _toDisplayString(coupon.code), 1),
                                                    _createElementVNode("span", _hoisted_124, "-" + _toDisplayString(formatPrice(coupon.discountAmount || 0)) + " CHF", 1)
                                                ]),
                                                _createElementVNode("button", {
                                                    onClick: ($event) => (removeCoupon(coupon.code)),
                                                    class: "remove-coupon-btn",
                                                    type: "button"
                                                }, [...(_cache[33] || (_cache[33] = [
                                                        _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                                                    ]))], 8, _hoisted_125)
                                            ]));
                                        }), 128))
                                    ]))
                                    : _createCommentVNode("", true),
                                (canAddMoreCoupons.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                                        _createElementVNode("div", _hoisted_127, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((couponCode).value = $event)),
                                                type: "text",
                                                placeholder: _unref(t)('pos.enterPromoCode'),
                                                class: "coupon-input",
                                                disabled: isApplyingCoupon.value,
                                                onKeyup: _withKeys(applyCouponCode, ["enter"])
                                            }, null, 40, _hoisted_128), [
                                                [_vModelText, couponCode.value]
                                            ]),
                                            _createElementVNode("button", {
                                                onClick: applyCouponCode,
                                                disabled: !couponCode.value.trim() || isApplyingCoupon.value,
                                                class: "apply-coupon-btn",
                                                type: "button"
                                            }, [
                                                (isApplyingCoupon.value)
                                                    ? (_openBlock(), _createElementBlock("i", _hoisted_130))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_131, _toDisplayString(_unref(t)('pos.apply')), 1))
                                            ], 8, _hoisted_129)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            (storeOrderType.value === 'delivery')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                                    _createElementVNode("div", _hoisted_133, [
                                        (restaurantMinOrder.value > 0)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                type: "button",
                                                class: "btn-disable-min-order",
                                                onClick: disableMinOrder
                                            }, [
                                                _cache[34] || (_cache[34] = _createElementVNode("span", { class: "btn-icon" }, "🚫", -1)),
                                                _createElementVNode("span", _hoisted_134, _toDisplayString(_unref(t)('pos.disableMinOrder')), 1)
                                            ]))
                                            : (originalMinOrder.value > 0)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 1,
                                                    type: "button",
                                                    class: "btn-enable-min-order",
                                                    onClick: enableMinOrder
                                                }, [
                                                    _cache[35] || (_cache[35] = _createElementVNode("span", { class: "btn-icon" }, "✅", -1)),
                                                    _createElementVNode("span", _hoisted_135, _toDisplayString(_unref(t)('pos.enableMinOrder')), 1)
                                                ]))
                                                : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_136, [
                                        (restaurantDeliveryFee.value > 0)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                type: "button",
                                                class: "btn-disable-min-order",
                                                onClick: disableDeliveryFee
                                            }, [...(_cache[36] || (_cache[36] = [
                                                    _createElementVNode("span", { class: "btn-icon" }, "🚫", -1),
                                                    _createElementVNode("span", { class: "btn-text" }, "Désactiver les frais de livraison", -1)
                                                ]))]))
                                            : (originalDeliveryFee.value > 0)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 1,
                                                    type: "button",
                                                    class: "btn-enable-min-order",
                                                    onClick: enableDeliveryFee
                                                }, [...(_cache[37] || (_cache[37] = [
                                                        _createElementVNode("span", { class: "btn-icon" }, "✅", -1),
                                                        _createElementVNode("span", { class: "btn-text" }, "Réactiver les frais de livraison", -1)
                                                    ]))]))
                                                : _createCommentVNode("", true)
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_137, [
                                _createElementVNode("div", _hoisted_138, [
                                    _createElementVNode("label", null, _toDisplayString(_unref(t)('pos.discountType')), 1),
                                    _createElementVNode("div", _hoisted_139, [
                                        _createElementVNode("label", _hoisted_140, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "radio",
                                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((discountType).value = $event)),
                                                value: "percentage",
                                                onChange: handleDiscountTypeChange
                                            }, null, 544), [
                                                [_vModelRadio, discountType.value]
                                            ]),
                                            _createElementVNode("span", null, _toDisplayString(_unref(t)('pos.percentage')), 1)
                                        ]),
                                        _createElementVNode("label", _hoisted_141, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "radio",
                                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((discountType).value = $event)),
                                                value: "fixed",
                                                onChange: handleDiscountTypeChange
                                            }, null, 544), [
                                                [_vModelRadio, discountType.value]
                                            ]),
                                            _createElementVNode("span", null, _toDisplayString(_unref(t)('pos.fixedAmount')), 1)
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_142, [
                                    (discountType.value === 'percentage')
                                        ? (_openBlock(), _createElementBlock("label", _hoisted_143, _toDisplayString(_unref(t)('pos.discountPercentage')), 1))
                                        : (_openBlock(), _createElementBlock("label", _hoisted_144, _toDisplayString(_unref(t)('pos.discountFixed')), 1)),
                                    _createElementVNode("div", _hoisted_145, [
                                        (discountType.value === 'percentage')
                                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                key: 0,
                                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((discountPercentage).value = $event)),
                                                type: "number",
                                                min: "0",
                                                max: "100",
                                                step: "0.1",
                                                placeholder: "0",
                                                class: "discount-input",
                                                onInput: handleDiscountChange
                                            }, null, 544)), [
                                                [_vModelText, discountPercentage.value]
                                            ])
                                            : _withDirectives((_openBlock(), _createElementBlock("input", {
                                                key: 1,
                                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((discountFixed).value = $event)),
                                                type: "number",
                                                min: "0",
                                                step: "0.01",
                                                placeholder: "0.00",
                                                class: "discount-input",
                                                onInput: handleFixedDiscountChange
                                            }, null, 544)), [
                                                [_vModelText, discountFixed.value]
                                            ]),
                                        _createElementVNode("span", _hoisted_146, _toDisplayString(discountType.value === "percentage" ? "%" : "CHF"), 1)
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_147, [
                                _createElementVNode("div", _hoisted_148, [
                                    _createElementVNode("label", null, _toDisplayString(_unref(t)('pos.miscellaneous')), 1),
                                    _createElementVNode("div", _hoisted_149, [
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((diversAmount).value = $event)),
                                            type: "number",
                                            min: "0",
                                            step: "0.01",
                                            placeholder: "0.00",
                                            class: "discount-input",
                                            onInput: handleDiversChange
                                        }, null, 544), [
                                            [_vModelText, diversAmount.value]
                                        ]),
                                        _cache[38] || (_cache[38] = _createElementVNode("span", { class: "discount-symbol" }, "CHF", -1))
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_150, [
                                _createElementVNode("div", _hoisted_151, [
                                    _createElementVNode("label", null, _toDisplayString(_unref(t)('pos.slice')), 1),
                                    _createElementVNode("div", _hoisted_152, [
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((isTrancher).value = $event)),
                                            type: "radio",
                                            value: "true"
                                        }, null, 512), [
                                            [_vModelRadio, isTrancher.value]
                                        ]),
                                        _createElementVNode("span", null, _toDisplayString(_unref(t)('pos.yes')), 1),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((isTrancher).value = $event)),
                                            type: "radio",
                                            value: "false"
                                        }, null, 512), [
                                            [_vModelRadio, isTrancher.value]
                                        ]),
                                        _createElementVNode("span", null, _toDisplayString(_unref(t)('pos.no')), 1)
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_153, [
                                _createElementVNode("div", _hoisted_154, [
                                    _createElementVNode("label", null, _toDisplayString(_unref(t)('pos.note')), 1),
                                    _createElementVNode("div", _hoisted_155, [
                                        _withDirectives(_createElementVNode("textarea", {
                                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((SpecialInstructions).value = $event)),
                                            placeholder: _unref(t)('pos.notePlaceholder'),
                                            class: "discount-input",
                                            rows: "3"
                                        }, null, 8, _hoisted_156), [
                                            [_vModelText, SpecialInstructions.value]
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_157, [
                                _createElementVNode("div", _hoisted_158, [
                                    _createElementVNode("span", _hoisted_159, _toDisplayString(_unref(t)('pos.subtotal')), 1),
                                    _createElementVNode("span", _hoisted_160, _toDisplayString(formatPrice(storeCartTotal.value)) + " CHF", 1)
                                ]),
                                (discountAmount.value > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_161, [
                                        _createElementVNode("span", _hoisted_162, [
                                            _createTextVNode(_toDisplayString(_unref(t)('pos.discountLabel')) + " ", 1),
                                            (discountType.value === 'percentage')
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_163, "(" + _toDisplayString(discountPercentage.value) + "%)", 1))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_164, "(" + _toDisplayString(formatPrice(discountFixed.value)) + " CHF)", 1))
                                        ]),
                                        _createElementVNode("span", _hoisted_165, "-" + _toDisplayString(formatPrice(discountAmount.value)) + " CHF", 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                (couponDiscountAmount.value > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_166, [
                                        _createElementVNode("span", _hoisted_167, "Coupons (" + _toDisplayString(appliedCoupons.value.map(c => c.code).join(', ')) + ")", 1),
                                        _createElementVNode("span", _hoisted_168, "-" + _toDisplayString(formatPrice(couponDiscountAmount.value)) + " CHF", 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                (minOrderSupplement.value > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_169, [
                                        _createElementVNode("span", _hoisted_170, _toDisplayString(_unref(t)('pos.minOrderSupplement')), 1),
                                        _createElementVNode("span", _hoisted_171, "+" + _toDisplayString(formatPrice(minOrderSupplement.value)) + " CHF", 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                (restaurantDeliveryFee.value > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_172, [
                                        _cache[39] || (_cache[39] = _createElementVNode("span", { class: "label" }, "Frais de livraison", -1)),
                                        _createElementVNode("span", _hoisted_173, "+" + _toDisplayString(formatPrice(restaurantDeliveryFee.value)) + " CHF", 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                (diversAmount.value > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
                                        _createElementVNode("span", _hoisted_175, _toDisplayString(_unref(t)('pos.miscellaneousLabel')), 1),
                                        _createElementVNode("span", _hoisted_176, "+" + _toDisplayString(formatPrice(diversAmount.value)) + " CHF", 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_177, [
                                    _createElementVNode("span", _hoisted_178, _toDisplayString(_unref(t)('pos.vat', { rate: taxRate.value })), 1),
                                    _createElementVNode("span", _hoisted_179, _toDisplayString(formatPrice(vatAmount.value)) + " CHF", 1)
                                ]),
                                _createElementVNode("div", _hoisted_180, [
                                    _createElementVNode("span", _hoisted_181, _toDisplayString(_unref(t)('pos.total')), 1),
                                    _createElementVNode("span", _hoisted_182, _toDisplayString(formatPrice(finalTotalWithCoupon.value)) + " CHF", 1)
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (storeCart.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_183, [
                            _createElementVNode("h3", _hoisted_184, _toDisplayString(_unref(t)('pos.paymentMethod')), 1),
                            _createElementVNode("div", _hoisted_185, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(paymentMethods, (method) => {
                                    return _createElementVNode("button", {
                                        key: method.id,
                                        class: _normalizeClass([
                                            'payment-btn',
                                            { active: selectedPaymentMethod.value === method.id },
                                        ]),
                                        onClick: ($event) => (selectPaymentMethod(method.id))
                                    }, [
                                        _createElementVNode("span", _hoisted_187, _toDisplayString(getPaymentIcon(method.icon)), 1),
                                        _createElementVNode("span", null, _toDisplayString(method.name), 1)
                                    ], 10, _hoisted_186);
                                }), 64))
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (storeCart.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_188, [
                            _createElementVNode("button", {
                                onClick: handlePlaceOrder,
                                disabled: !canPlaceOrder.value || isProcessingOrder.value,
                                class: "place-order-btn"
                            }, [
                                _createElementVNode("i", {
                                    class: _normalizeClass(isProcessingOrder.value ? 'fas fa-spinner fa-spin' : 'fas fa-receipt')
                                }, null, 2),
                                _createTextVNode(" " + _toDisplayString(isProcessingOrder.value ? _unref(t)('pos.processing') : _unref(t)('pos.validateOrder')) + " ", 1),
                                _createElementVNode("span", _hoisted_190, _toDisplayString(formatPrice(finalTotalWithCoupon.value)) + " CHF", 1)
                            ], 8, _hoisted_189)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
